import { FunctionComponent } from 'react'

const Loading: FunctionComponent = () => (
  <div className='pv12 lite-grey flex flex-column items-center f3'>
    <span className='w7'><i className='loading' /></span>
  </div>
)

export default Loading
